export const GLOBAL_AUTH_UNAUTHORIZED_MESSAGE = "Unauthorized: global auth";
export const MART_AUTH_UNAUTHORIZED_MESSAGE = "Unauthorized: mart auth";
